import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -5,
    government: -10,
    office: -15,
  },
  education: {
    childcare: -15,
    high_school: -10,
    library: -5,
    primary: -10,
    university: -5,
  },
  essentials: {
    electricity: 5,
    gas: 5,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 15,
    fast_food: 10,
    restaurant: 12,
  },
  health: {
    clinic: 10,
    dentist: -5,
    hospital: 5,
    pharmacy: 10,
  },
  nature: {
    beach: 15,
    forest: 15,
    lake: 15,
    mountain: 15,
    park: 12,
    river: 15,
  },
  religion: {
    church: -10,
    mosque: -10,
  },
  shops: {
    grocery: 8,
    mall: 5,
  },
  soil: {
    clay: -5,
    loam: -5,
    peat: -10,
    salt: -5,
    sand: 10,
    silt: 0,
  },
  sport: {
    gym: 5,
    pool: 5,
  },
  telecom: {
    cable_tv: -15,
    fiber_optic: -5,
    network_4g: 12,
    network_5g: 10,
    phone: 10,
  },
  transport: {
    airport: 15,
    bus: 12,
    ferry: 10,
    gas_station: 10,
    metro: 7,
    parking: -5,
    taxi: 12,
    train: 8,
    tram: 10,
  },
};

export default PLACES_PROFILE;
